import { $api } from '@shared/api';
import { routes } from '@shared/api/routes';
import { keysToCamel } from '@shared/helpers/snakeToCamel';

type OnboardingHintsStateResponse = {
    status: 'success';
    data: {
        enabled: boolean;
        'completed_hints': string[];
    };
};

type OnboardingHintsState = {
    enabled: boolean;
    completedHints: string[];
};

export const getOnboardingHintsState = async (): Promise<OnboardingHintsState> => {
    const response = await $api.get<OnboardingHintsStateResponse>(routes.onboardingHintsState());

    return keysToCamel<OnboardingHintsState>(response.data.data);
};

export const completeOnboardingHint = async (hintId: string): Promise<void> => {
    await $api.post(routes.completeOnboardingHint(), { 'hint_id': hintId });
};
